import script from "./DemoWalkthrough.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoWalkthrough.vue?vue&type=script&setup=true&lang=ts"

import "./DemoWalkthrough.vue?vue&type=style&index=0&id=53156d09&scoped=true&lang=css"
import "./DemoWalkthrough.vue?vue&type=style&index=1&id=53156d09&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53156d09"]])

export default __exports__